"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCard = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CardMixin = require("../../mixins/components/CardMixin");
var StyledCard = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledCard",
  componentId: "c11n-8-107-0__sc-1w6p0lv-0"
})(["", ""], _CardMixin.CardMixin);
exports.StyledCard = StyledCard;